import { useState } from 'react';
import {
  Typography, List, ListItem, ListItemAvatar, ListItemText,
  Avatar, Badge, Box
} from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import StarIcon from '@mui/icons-material/Star';
import NotificationDialog from './Messagebody';
import { useWebSocket } from '../../../WebSocketContext';

export default function NotificationsList({ notifications = [], email }) {
  const [selectedNotification, setSelectedNotification] = useState(null);
  const { markAsRead } = useWebSocket();

  const handleOpen = async (notification) => {
    setSelectedNotification(notification);

    if (!notification.read && !notification.read_at) {
      try {
        const res = await fetch(`https://signal.osoulworld.com/api/notifications/${notification.id}/status`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ status: "read" })
        });
        const updated = await res.json();
        markAsRead(updated.id);
      } catch (err) {
        console.error("Error updating notification status:", err);
      }
    }
  };

  const handleClose = () => {
    setSelectedNotification(null);
  };

  const getNotificationIcon = (notification, isRead) => {
    if (notification.icon) return <span>{notification.icon}</span>;
    if (isRead) return <MailOutlineIcon sx={{ color: '#9e9e9e' }} />;
    return <MailIcon sx={{ color: '#1976d2' }} />;
  };

  const formatDateSmart = (dateString) => {
    try {
      const date = new Date(dateString);
      const now = new Date();
      const diffMs = now - date;
      const diffMinutes = Math.floor(diffMs / (1000 * 60));
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      if (diffMinutes < 1) {
        return "now";
      }
      if (diffMinutes < 60) {
        return `${diffMinutes} m`;
      }
      if (diffHours < 24) {
        return `${diffHours} h`;
      }
      if (diffDays < 7) {
        return `${diffDays} d`;
      }
      return date.toLocaleDateString();
    } catch {
      return dateString;
    }
  };

  return (
    <>
      <Typography variant="h6" sx={{ px: 2, py: 1 }}>
        Messages & Notifications
      </Typography>
      <List sx={{ maxHeight: 400, overflowY: 'auto' }}>
        {notifications.length === 0 ? (
          <Typography variant="body2" sx={{ px: 2, py: 1 }}>
            لا توجد إشعارات جديدة
          </Typography>
        ) : (
          notifications.map((notification, index) => {
            const isRead = notification.read || notification.read_at;
            return (
              <ListItem
                key={notification.id || index}
                button
                onClick={() => handleOpen(notification)}
                sx={{
                  backgroundColor: isRead ? '#fafafa' : '#e3f2fd',
                  mb: 1,
                  borderRadius: 1,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                  <ListItemAvatar>
                    <Badge color="error" variant="dot" invisible={!!isRead}>
                      <Avatar>
                        {getNotificationIcon(notification, isRead)}
                      </Avatar>
                    </Badge>

                  </ListItemAvatar>

                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 'bold', maxWidth: '70%' }}
                          noWrap
                        >
                          {notification.rendered_title || notification.template?.title}
                        </Typography>
                        {notification?.sent_at && (
                          <Typography variant="caption" color="text.secondary" noWrap>
                            {formatDateSmart(notification.sent_at)}
                          </Typography>
                        )}
                      </Box>
                    }
                    secondary={
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        noWrap
                        sx={{ maxWidth: 250 }}
                      >
                        {notification.rendered_body || notification.template?.body || notification.message}
                      </Typography>
                    }
                  />
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                  {notification.priority > 0 && (
                    <StarIcon sx={{ color: '#fbc02d' }} />
                  )}
                </Box>
              </ListItem>
            );
          })
        )}
      </List>

      <NotificationDialog
        open={Boolean(selectedNotification)}
        onClose={handleClose}
        notification={selectedNotification}
      />
    </>
  );
}
